import './styles.scss'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Dialog } from 'primereact/dialog'
import { Sidebar } from 'primereact/sidebar'
import { doc, onSnapshot } from 'firebase/firestore'
import { getLocalAppSettings, getLocalUserDetails, getLocalFreeNewsLanguageId, getLocalLoggedInStatus, getLocalAppLanguage, getLocalSingleDeviceId, setLocalWithFreeNewsLanguageId, setLocalWithCurrentLocation, setLocalWithAppSettings, setLocalWithSingleDeviceId, getLocalTheme, setLocalWithTheme, getLocalFreeBusinessGeneralMenus } from 'Utils/LocalStorage_Handler'
import { coffeewebLogo, ROUTE_STRINGS, STATIC_ROUTE_STRINGS } from 'Utils/Constants'
import { commonMethods, useTabView1024 } from 'Utils/commonMethods'
import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import { devEnvLogo, Facebook, WhatsApp, Instagram, Youtube, Twitter, LinkedIn, Quora, Tumblr, Telegram, Medium, Pinterest, Thread } from 'Assets/Icons'
import useAnalytics from 'Utils/useAnalytics'
import { USER_EVENTS } from 'Utils/Constants/analyticsEvents'
import NotificationListenService from './NotificationDropdown'
import { db } from '../../../firebase'
import ProfileModal from './Components/ProfileModal'
import LogoutModal from './Components/LogoutModal'
import AppLinks from '../AppLinks'

const Header = ({ testingHeaderFlag }) => {
  const history = useHistory()
  const { i18n, t } = useTranslation()
  const { isWebView, isMobileView } = useTabView1024()
  const { generateUniqueId, refreshLocalStorage, dateFormatBasedOnUser } = commonMethods
  const { isLoading, setKey } = useContext(CoffeeWebContext)
  const { trackEvent } = useAnalytics()
  const overlayPanelRef = useRef(null)
  const buzzTimeoutRef = useRef(null)
  const defaultFlagUrl = 'https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png'

  const params = new URLSearchParams(window.location.search)
  const tab = params.get('tab')

  const appSettings = getLocalAppSettings()
  const userDetails = getLocalUserDetails()
  const freeNewsLanguageId = getLocalFreeNewsLanguageId()
  const freeMenusToDisplay = tab === 'general' ? getLocalFreeBusinessGeneralMenus()?.generalMenu : getLocalFreeBusinessGeneralMenus()?.businessMenu
  const userLoginStatus = getLocalLoggedInStatus()

  const isLoggedInStatus = userDetails?.isLoggedIn

  if (!freeNewsLanguageId) {
    setLocalWithFreeNewsLanguageId(1)
  }

  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false)
  const [showLogoutPopup, setShowLogoutPopup] = useState(false)
  const [modalShow, setModalShow] = React.useState(false)
  const [drawerState, setDrawerState] = React.useState(false)
  const [currentCity, setCurrentCity] = useState(null)
  const [countryFlagUrl, setCountryFlagUrl] = useState(null)
  const [menuDetails, setMenuDetails] = useState([])
  const [currentDateTime, setCurrentDateTime] = useState({ currentDate: '', currentTime: '' })
  const [isTrialPeriodData, setIsTrialPeriodData] = useState([])
  const [isTrialUser, setIsTrialUser] = useState(userDetails?.isTrialUser)
  const [isDialogVisible, setDialogVisible] = useState(false)
  const [displayUrl, setDisplayUrl] = useState('')
  const [currentTheme, setCurrentTheme] = useState('')
  const [showAppLikns, setShowAppLinks] = useState(false)
  const [buzzAnimation, setBuzzAnimation] = useState(false)
  const [activeTab, setActiveTab] = useState('business') // Default to 'business'

  const { currentDate, currentTime } = currentDateTime
  const pageUrl = window.location.pathname
  const splitPageUrl = pageUrl.split('/')
  const currentUrl = splitPageUrl.pop()

  const getFreeMenusToDisplay = () => {
    const freeBusinessGeneralMenus = getLocalFreeBusinessGeneralMenus()

    if (!freeBusinessGeneralMenus) return []

    if (activeTab === 'business') {
      return freeBusinessGeneralMenus?.businessMenu || []
    }

    return freeBusinessGeneralMenus?.generalMenu || []
  }

  // Helper function to determine which tab a route belongs to
  const getTabForCurrentRoute = () => {
    const currentPath = window.location.pathname

    if (!userDetails?.businessGeneralMenus) return 'business'

    const businessMenus = userDetails.businessGeneralMenus?.businessMenu || []
    const generalMenus = userDetails.businessGeneralMenus?.generalMenu || []

    // Check if current route is in business menus
    const isInBusiness = businessMenus.some((menu) => currentPath.includes(menu.menuUrl))

    // Check if current route is in general menus
    const isInGeneral = generalMenus.some((menu) => currentPath.includes(menu.menuUrl))

    if (isInBusiness) return 'business'
    if (isInGeneral) return 'general'

    // Default to business if route not found in either
    return 'business'
  }

  // useEffect to initialize state for testing purposes
  useEffect(() => {
    if (testingHeaderFlag) {
      setModalShow(testingHeaderFlag)
      setDrawerState(testingHeaderFlag)
      setMenuDetails(userDetails?.menus)
    }
  }, [])

  // Set active tab based on current route on mount (handles refresh)
  useEffect(() => {
    const tabForRoute = getTabForCurrentRoute()

    setActiveTab(tabForRoute)
  }, [])

  useEffect(() => {
    const root = document.documentElement

    // commonMethods.setTheme(root, window.location)
    setTheme(getLocalTheme() || 'light')
  }, [window.location.pathname])

  useEffect(() => {
    const theme = getLocalTheme()

    getApiSettings()
    setTheme(theme || 'light')
    setCurrentTheme(theme || 'light')

    if (isLoggedInStatus) {
      const unsubscribe = init()

      return () => {
        unsubscribe()
      }
    }
  }, [isLoggedInStatus])

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const locationResponse = await commonMethods.searchLocation()
        const response = await apiAdapterCoffeeWeb.getAllCountries()
        const countryData = response?.data.find((item) => item?.nicename === locationResponse?.country)

        setLocalWithCurrentLocation(locationResponse)
        setCurrentCity(locationResponse?.name)
        setCountryFlagUrl(countryData?.flagsUrl)
      } catch (error) {
        console.error('Error getting geolocation:', error)
      }
    }

    if (isMobileView && !isLoggedInStatus) {
      fetchLocation()
    }
  }, [isMobileView, isLoggedInStatus])

  useEffect(() => {
    let intervalId

    if (drawerState && isMobileView && !isLoggedInStatus) {
      updateDateTime()
      intervalId = setInterval(updateDateTime, 1000)
    }

    return () => {
      clearInterval(intervalId)
    }
  }, [drawerState, isMobileView, isLoggedInStatus])

  useEffect(() => {
    if (isMobileView) {
      document.querySelector('body').style.overflow = drawerState ? 'hidden' : 'auto'
    }
  }, [drawerState])

  useEffect(() => {
    if (!userDetails?.menus || userDetails?.menus.length === 0) {
      return
    }

    // Check in menus
    const checkForMenu = userDetails.menus.findIndex((ele) => ele.menuUrl === currentUrl)

    // Check in subMenuModels if main menu check fails
    const checkForSubMenu = userDetails.menus.flatMap((menu) => menu.subMenuModels || []).findIndex((ele) => ele.menuUrl === currentUrl)

    if (checkForMenu !== -1) {
      setDisplayUrl(userDetails.menus[checkForMenu]?.menuName || '')
    } else if (checkForSubMenu !== -1) {
      const foundSubMenu = userDetails.menus.flatMap((menu) => menu.subMenuModels || [])[checkForSubMenu]

      setDisplayUrl(foundSubMenu?.menuName || '')
    } else {
      setDisplayUrl('')
    }
  }, [userDetails, currentUrl])

  const updateDateTime = () => {
    const updatedDateTime = commonMethods.updateDateTime()

    setCurrentDateTime(updatedDateTime)
  }

  const init = () => {
    const unSub = onSnapshot(doc(db, process.env.REACT_APP_ENVIRONMENT === 'develop' ? 'CoffeeWeb_Devp' : 'CoffeeWeb', userDetails?.googlesignid ? userDetails?.email : userDetails?.phone), (doc) => {
      const response = doc.data()
      const singleDeviceId = getLocalSingleDeviceId()
      const userDetails = getLocalUserDetails()
      const isLoggedInStatus = userDetails?.isLoggedIn

      setIsTrialPeriodData(response)
      setIsTrialUser(response?.IsTrialUser)

      if (response) {
        if (response?.WebDeviceId !== singleDeviceId && isLoggedInStatus) {
          clearStorage('setNewDeviceId')
        } else if (response.LoginStatus === 'Log-Off' && !sessionStorage.getItem('logoutFlag')) {
          clearStorage()
        }
      }
    })

    if (userDetails?.menus !== null) {
      setMenuDetails(userDetails?.menus)
    }

    return () => {
      unSub()
    }
  }

  const getApiSettings = async () => {
    try {
      const response = await apiAdapterCoffeeWeb.appSetting()

      if (response?.data?.id) {
        setLocalWithAppSettings(response?.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const clearStorage = (setNewDeviceId) => {
    setShowLogoutPopup(true)
    setTimeout(() => {
      const { singleDeviceId } = refreshLocalStorage()

      if (setNewDeviceId) {
        setLocalWithSingleDeviceId(generateUniqueId())
      } else {
        setLocalWithSingleDeviceId(singleDeviceId)
      }

      sessionStorage.clear()
      setShowLogoutPopup(false)
      history.push(ROUTE_STRINGS.guestCoffeeQuotes)
    }, 5100)
  }

  const handleOpenForProfileSetting = () => {
    setDrawerState(false)
    setModalShow(true)
  }

  const openProfileSetting = () => {
    setDrawerState(false)
    setModalShow(true)
  }

  const navigateToSubscription = (event) => {
    setDrawerState(false)
    event.stopPropagation()
    history.push(ROUTE_STRINGS.subscription)
  }

  const handleExploreMenuURL = (menu) => {
    setDisplayUrl(menu.menuName)
  }

  function generateLinearGradientColor() {
    const defaultColor = '#50b3f6'
    const color = userDetails?.sub?.subscriptionColor || defaultColor

    const colorPart1 = color.slice(0, 7)
    const colorPart2 = color.slice(9, 16)
    const colorPart3 = color.slice(18, 27)

    return `linear-gradient(100deg, ${colorPart1}, ${colorPart2}, ${colorPart3})`
  }

  const handleClose = () => {
    const userLanguage = getLocalAppLanguage()

    i18n.changeLanguage(userLanguage)
    setModalShow(false)
  }

  const handleLogin = () => {
    if (userLoginStatus === false) {
      history.push(ROUTE_STRINGS.login)
    } else {
      history.push(ROUTE_STRINGS.createAccount)
    }
  }

  const redirectToHome = () => {
    if (userLoginStatus) {
      history.push(ROUTE_STRINGS.coffeequotes)
    } else {
      history.push(ROUTE_STRINGS.guestCoffeeQuotes)
    }
  }

  const showLogoutConfirmationModal = () => {
    setIsLogoutModalVisible(true)
    setDrawerState(false)
    trackEvent(USER_EVENTS.PROFILE_LOGOUT_BTN)
  }

  const handleProfileMouseEnter = () => {
    if (overlayPanelRef.current) {
      overlayPanelRef.current.hide()
    }
  }

  const validityFormatter = (date) => {
    const [validityString, validTill] = date.split(':').map((el) => el.trim())

    return `${validityString}: ${dateFormatBasedOnUser(validTill, 'spaceFormat')}`
  }

  const leftSideLinks = [
    { url: 'https://coffeewebdotcom.quora.com/', logo: <Quora />, altText: 'quora', className: 'quora' },
    { url: 'https://www.tumblr.com/blog/coffeewebdotcom', logo: <Tumblr />, altText: 'tumblr', className: 'tumblr' },
    { url: 'https://t.me/CoffeeWebDotCom', logo: <Telegram />, altText: 'telegram', className: 'telegram' },
    { url: 'https://medium.com/@coffeewebdotcom', logo: <Medium />, altText: 'medium', className: 'medium' },
    { url: 'https://in.pinterest.com/CoffeeWebDotCom/', logo: <Pinterest />, altText: 'pinterest', className: 'pinterest' },
    { url: 'https://www.threads.net/@coffeewebdotcom', logo: <Thread />, altText: 'thread', className: 'thread' }
  ]

  const rightSideLinks = [
    { url: 'https://www.linkedin.com/company/coffeewebdotcom', logo: <LinkedIn />, altText: 'linkedin', className: 'linkedin' },
    { url: 'https://whatsapp.com/channel/0029Va5JryJDeONFtCLCVA0Z', logo: <WhatsApp />, altText: 'whatsapp', className: 'whatsapp' },
    { url: 'https://www.youtube.com/@CoffeeWebDotCom', logo: <Youtube />, altText: 'youtube', className: 'youtube' },
    { url: 'https://x.com/CoffeeWebDotCom', logo: <Twitter />, altText: 'twitter', className: 'twitter' },
    { url: 'https://www.instagram.com/coffeewebdotcom/', logo: <Instagram />, altText: 'instagram', className: 'instagram' },
    { url: 'https://www.facebook.com/CoffeeWebDotCom', logo: <Facebook />, altText: 'facebook', className: 'facebook' }
  ]

  const SocialMediaLink = ({ logo, altText, url, className }) => (
    <div className="social-icon-wrapper">
      <a href={url} target="_blank" rel="noopener noreferrer" className={`icon-container ${className}`} aria-label={altText}>
        {logo}
      </a>
    </div>
  )

  const subscriptionColor = isTrialPeriodData?.subscriptionDetails?.SubscriptionColor || userDetails?.sub?.subscriptionColor || '#ae5e49'

  const primaryColor = subscriptionColor.length >= 7 ? subscriptionColor.slice(0, 7) : '#ae5e49'

  const gradientColors = subscriptionColor.length > 7 ? [subscriptionColor.slice(0, 7), subscriptionColor.slice(9, 16), subscriptionColor.slice(18, 27)] : ['#ae5e49', '#ae5e49', '#ae5e49']

  const backgroundGradient = `linear-gradient(100deg, 
${gradientColors[0]}, 
${gradientColors[1]}, 
${gradientColors[2]})`

  const style = {
    backgroundImage: backgroundGradient,
    animation: 'gradient 7s ease infinite'
  }

  const borderStyle = {
    border: `2px solid ${primaryColor}`,
    color: primaryColor,
    padding: '1px 15px'
  }

  const exploreMenu = userDetails?.menus?.find((menu) => menu.subMenuModels?.length > 0)
  const subMenus = exploreMenu?.subMenuModels || []

  const freeSubMenus = freeMenusToDisplay?.find((menu) => menu.subMenuModels?.length > 0)

  // Add coffeewebViewMenus array similar to Menubar
  const coffeewebViewMenus = ['coffeecast', 'coffee-games', 'coffee-community', 'coffeecart', 'coffee-post']

  // eslint-disable-next-line
  const transformMenuUrl = (url) => '/dashboard/' + url

  // Helper function to get the correct navigation URL for a menu (similar to Menubar)
  const getMenuNavigationUrl = (menuUrl) => {
    // Normalize the menuUrl by removing leading slash and converting to lowercase
    const normalizedMenuUrl = menuUrl?.replace(/^\//, '')?.toLowerCase()

    // Check if this menu should use coffeeweb route with view params
    if (coffeewebViewMenus.includes(normalizedMenuUrl)) {
      return `${ROUTE_STRINGS.coffeeweb}?view=${normalizedMenuUrl}`
    }
    // For all other menus (including coffeewebAi), use normal route transformation

    return transformMenuUrl(menuUrl)
  }

  // Filter menus based on active tab (business/general) similar to Menubar
  const getFilteredMenus = () => {
    if (!userDetails?.businessGeneralMenus) {
      // Fallback to original menus if businessGeneralMenus is not available
      return menuDetails || []
    }

    if (activeTab === 'business') {
      return userDetails.businessGeneralMenus?.businessMenu || []
    }

    return userDetails.businessGeneralMenus?.generalMenu || []
  }

  const filteredMenus = getFilteredMenus()

  // Debug: Log filtered menus after filtering
  const displayableMenus = filteredMenus?.filter((ele) => {
    const hasSubMenus = ele.subMenuModels?.length > 0
    const isDisplayable = ele.isWebDisplayEnable === true && ele.isLaunch === true && ele.menuUrl !== null

    return !hasSubMenus && isDisplayable
  })

  // Handle tab switching with navigation to default routes
  const handleTabSwitch = (tab) => {
    if (tab === activeTab) return // Don't do anything if clicking the same tab

    setActiveTab(tab)

    // Handle guest user navigation
    if (!isLoggedInStatus) {
      const freeBusinessGeneralMenus = getLocalFreeBusinessGeneralMenus()

      if (tab === 'business') {
        // Navigate to Coffee Quotes (first business menu item) for guest users
        const businessMenus = freeBusinessGeneralMenus?.businessMenu || []
        const coffeeQuotesMenu = businessMenus.find((menu) => menu.menuUrl === 'CoffeeQuotes')

        if (coffeeQuotesMenu) {
          history.push(ROUTE_STRINGS.guestCoffeeQuotes)
        } else if (businessMenus.length > 0) {
          // Fallback to first menu item
          const firstMenu = businessMenus[0]

          history.push(firstMenu.menuUrl === 'CoffeeQuotes' ? ROUTE_STRINGS.guestCoffeeQuotes : transformMenuUrl(firstMenu.menuUrl))
        }
      } else if (tab === 'general') {
        // Navigate to first general menu item for guest users
        const generalMenus = freeBusinessGeneralMenus?.generalMenu || []

        if (generalMenus.length > 0) {
          // Navigate to coffeeweb with default view
          history.push(`${ROUTE_STRINGS.guestCoffeeWeb}?view=${ROUTE_STRINGS.coffeePost || 'coffee-post'}&tab=general`)
        } else {
          // Fallback if no general menus
          history.push(`${ROUTE_STRINGS.guestCoffeeWeb}?view=${ROUTE_STRINGS.coffeePost || 'coffee-post'}&tab=general`)
        }
      }

      return // Exit early for guest users
    }

    // Navigate to default route for the selected tab
    if (tab === 'business') {
      // Navigate to Coffee Quotes (first business menu item)
      const businessMenus = userDetails?.businessGeneralMenus?.businessMenu || []
      const coffeeQuotesMenu = businessMenus.find((menu) => menu?.menuUrl === 'CoffeeQuotes')

      if (coffeeQuotesMenu) {
        history.push(transformMenuUrl(coffeeQuotesMenu.menuUrl))
      }
    } else if (tab === 'general') {
      // Navigate to Coffee Community (coffeeweb) using view param
      const generalMenus = userDetails?.businessGeneralMenus?.generalMenu || []
      const coffeeCommunityMenu = generalMenus.find((menu) => menu.menuUrl === 'coffee-community')

      if (coffeeCommunityMenu) {
        history.push(`${ROUTE_STRINGS.coffeeweb}?view=coffee-community`)
      }
    }
  }

  const setTheme = (theme) => {
    const root = document.documentElement
    const currentPath = pageUrl?.split('/')[2]
    const guestCurrentPath = pageUrl.split('/')[1]

    const coffeewebPath = ROUTE_STRINGS.coffeeweb.split('/')[2]
    const guestCoffeeWebPath = ROUTE_STRINGS.guestCoffeeWeb.split('/')[1]

    if (theme === 'light') {
      // apply light theme
      root.style.setProperty('--primary-bg-color', '#fff')
      root.style.setProperty('--secondary-bg-color', '#f3f3f3')
      root.style.setProperty('--primary-text-color', '#212529')
      root.style.setProperty('--primary-border-color', '1px solid #dee2e6')
      root.style.setProperty('--secondary-border-color', '1px solid lightblue')
      root.style.setProperty('--lightblue-bg-color', '#e9f1f9')
      root.style.setProperty('--modal-bg-color', '#fff')
      root.style.setProperty('--table-flickering-bg-color', '#ccc')
      root.style.setProperty('--secondary-brown-bg', '#ae5d491b')
      root.style.setProperty('--secondary-brown-text', '#3b4a54')
      root.style.setProperty('--coffeeWeb-primary-color', '#a0a0a0')
      root.style.setProperty('--coffeeWeb-secondary-color', '#f3f3f3')
      root.style.setProperty('--contrast-text-color', '#000')

      if (currentPath === coffeewebPath || guestCurrentPath === guestCoffeeWebPath) {
        // -- coffeeWeb specific variables
        root.style.setProperty('--coffeeWeb-bg-primary', '#fff')
        root.style.setProperty('--coffeeWeb-bg-secondary', '#fff')
        root.style.setProperty('--coffeeWeb-text-color', '#000')
        root.style.setProperty('--coffeeWeb-primary-text-color', '#000')
        root.style.setProperty('--coffeeWeb-font-weight', '500')
        root.style.setProperty('--coffeeWeb-hover-primary', '#a0a0a0')
        root.style.setProperty('--coffeeWeb-border-primary', '0px solid #a0a0a0')
        root.style.setProperty('--coffeeWeb-border-secondary', '1px solid #a0a0aa')
        root.style.setProperty('--theme-primary', '#ae5e49')
        root.style.setProperty('--primary-hover-bg', '#8e4b39')
      } else {
        // -- coffeeWeb specific variables
        root.style.setProperty('--coffeeWeb-bg-primary', '#50b3f6')
        root.style.setProperty('--coffeeWeb-bg-secondary', '#fff')
        root.style.setProperty('--coffeeWeb-text-color', '#fff')
        root.style.setProperty('--coffeeWeb-primary-text-color', '#50b3f6')
        root.style.setProperty('--coffeeWeb-font-weight', '700')
        root.style.setProperty('--coffeeWeb-hover-primary', '#2471a3')
        root.style.setProperty('--coffeeWeb-border-primary', '1px solid #50b3f6')
        root.style.setProperty('--coffeeWeb-border-secondary', '1px solid none')
        root.style.setProperty('--theme-primary', '#50b3f6')
        root.style.setProperty('--primary-hover-bg', '#2471a3')
      }
    } else {
      // apply dark theme
      root.style.setProperty('--primary-bg-color', '#252525')
      root.style.setProperty('--secondary-bg-color', '#404040')
      root.style.setProperty('--primary-text-color', '#d5d5d5')
      root.style.setProperty('--primary-border-color', '1px solid #373737')
      root.style.setProperty('--secondary-border-color', '1px solid #373737')
      root.style.setProperty('--lightblue-bg-color', '#333333')
      root.style.setProperty('--modal-bg-color', '#2d2d2d')
      root.style.setProperty('--table-flickering-bg-color', '#555')
      root.style.setProperty('--secondary-brown-bg', 'rgba(115, 68, 58, 0.57)')
      root.style.setProperty('--secondary-brown-text', '#cdcdcd')
      root.style.setProperty('--coffeeWeb-primary-color', '#a0a0a0')
      root.style.setProperty('--coffeeWeb-secondary-color', '#404040')
      root.style.setProperty('--contrast-text-color', '#fff')

      if (currentPath === coffeewebPath || guestCurrentPath === guestCoffeeWebPath) {
        // -- coffeeWeb specific variables
        root.style.setProperty('--coffeeWeb-bg-primary', '#252525')
        root.style.setProperty('--coffeeWeb-bg-secondary', '#252525')
        root.style.setProperty('--coffeeWeb-text-color', '#fff')
        root.style.setProperty('--coffeeWeb-primary-text-color', '#fff')
        root.style.setProperty('--coffeeWeb-font-weight', '500')
        root.style.setProperty('--coffeeWeb-hover-primary', '#a0a0a0')
        root.style.setProperty('--coffeeWeb-border-primary', '0px solid #a0a0a0')
        root.style.setProperty('--coffeeWeb-border-secondary', '1px solid #a0a0aa')
        root.style.setProperty('--theme-primary', '#ae5e49')
        root.style.setProperty('--primary-hover-bg', '#8e4b39')
      } else {
        // -- coffeeWeb specific variables
        root.style.setProperty('--coffeeWeb-bg-primary', '#50b3f6')
        root.style.setProperty('--coffeeWeb-bg-secondary', '#252525')
        root.style.setProperty('--coffeeWeb-text-color', '#fff')
        root.style.setProperty('--coffeeWeb-primary-text-color', '#50b3f6')
        root.style.setProperty('--coffeeWeb-font-weight', '700')
        root.style.setProperty('--coffeeWeb-hover-primary', '#2471a3')
        root.style.setProperty('--coffeeWeb-border-primary', '1px solid #50b3f6')
        root.style.setProperty('--coffeeWeb-border-secondary', '1px solid none')
        root.style.setProperty('--theme-primary', '#50b3f6')
        root.style.setProperty('--primary-hover-bg', '#2471a3')
      }
    }
  }

  const handleClickThemeChange = () => {
    trackEvent(USER_EVENTS.THEME_SWITCHED) // user-analytics

    const switchToTheme = currentTheme === 'light' ? 'dark' : 'light'

    setTheme(switchToTheme)
    setLocalWithTheme(switchToTheme)
    setCurrentTheme(switchToTheme)
    window.dispatchEvent(new Event('themeChanged'))
  }

  const handleShowAppLinks = (e) => {
    e.preventDefault()
    setShowAppLinks(true)
    setBuzzAnimation(true)

    if (buzzTimeoutRef.current) {
      clearTimeout(buzzTimeoutRef.current)
    }

    buzzTimeoutRef.current = setTimeout(() => {
      setBuzzAnimation(false)
      buzzTimeoutRef.current = null
    }, 200)
  }

  return (
    <>
      <div className={`pre-header ${isLoading ? 'is-loading' : ''}`} id="header" data-testid="header-main-container">
        <div className="newNavBar" data-testid="header-container">
          {/* Large Screen */}
          <div className="forLargeScreen" onClick={redirectToHome} data-testid="logo-container">
            <img className="coffeeWebLogo" alt="coffee-web-logo" src={process.env.REACT_APP_NODE_ENV === 'production' ? coffeewebLogo.transparentLogo : devEnvLogo} title="coffee-web-logo" />
          </div>

          {/* Mobile Screen */}
          {(!isWebView || testingHeaderFlag) && (
            <div className="forMobileScreen" data-testid="mobile-screen-container">
              {userLoginStatus ? <i className="pi pi-bars mobileScreenMenuIcon" onClick={() => setDrawerState(true)} data-testid="ham-burger-icon" /> : <img alt="coffee-web-logo" onClick={redirectToHome} src={process.env.REACT_APP_NODE_ENV === 'production' ? coffeewebLogo.transparentLogo : devEnvLogo} className="coffeeWebLogo" />}

              <Sidebar visible={drawerState} position={isLoggedInStatus ? 'left' : 'right'} onHide={() => setDrawerState(false)} className="mobileScreenDrawer" data-testid="side-bar-reuseable-component">
                <div className="mobileScreenLogoWrapper" data-testid="mobile-view-logo-container">
                  <img alt="" src={process.env.REACT_APP_NODE_ENV === 'production' ? coffeewebLogo.transparentLogo : devEnvLogo} title="mobile-view-logo-image" />
                  <div className="close-icon" data-testid="close-icon-container">
                    <i className="pi pi-times" onClick={() => setDrawerState(false)} data-testid="close-icon" />
                  </div>
                </div>

                <div className="sideBar" data-testid="side-bar-menu-container">
                  <div className="sideBarCardWrapper" data-testid="side-bar-card-wrapper">
                    <div className="sideBarCard" data-testid="side-bar-card" style={style}>
                      <div>
                        {/* User Country Image Div */}
                        <div>{userDetails?.countryFlag ? <img alt="country-flag" src={userDetails?.countryFlag} /> : <img alt="flag-india" src={countryFlagUrl || defaultFlagUrl} title="side-bar-default-flag"></img>}</div>

                        {/* User Details */}
                        <div>
                          {/* Name and Edit Button */}
                          <div>
                            <div className="userFirstLastName" onClick={() => openProfileSetting()} data-testid="mobile-view-user-name-container">
                              {userDetails?.firstName ? `${userDetails.firstName} ${userDetails.lastName}` : 'Guest User'}
                            </div>
                            <div className="EditButtonDiv" data-testid="mobile-view-pencil-container">
                              <i className="pi pi-pencil" data-testid="mobile-view-pencil-icon" onClick={userDetails ? () => openProfileSetting() : (e) => handleShowAppLinks(e)} />
                            </div>
                          </div>
                          {/* Users Occupation,Phone Number, Email */}
                          <div>
                            {userDetails?.occupationName !== 'NA' && (
                              <div onClick={() => openProfileSetting()} data-testid="mobile-view-occupation-container">
                                {userDetails?.occupationName}
                              </div>
                            )}
                            {userLoginStatus ? (
                              userDetails?.phone && (
                                <div onClick={() => openProfileSetting()} data-testid="mobile-view-phone-number-container">
                                  +{userDetails?.countryPhoneCode} {userDetails?.phone}
                                </div>
                              )
                            ) : (
                              <div>{currentCity}</div>
                            )}
                            {userDetails?.email && (
                              <div onClick={() => openProfileSetting()} data-testid="mobile-view-email-container">
                                {userDetails?.email}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {userLoginStatus ? (
                        <div>
                          <div>
                            {userDetails?.sub?.endDate && userDetails?.sub?.subType !== 1 && <div data-testid="mobile-view-subscription-valid-days-container"> {userDetails?.sub?.subscriptionValidTill}</div>}
                            {userDetails?.sub?.endDate && userDetails?.sub?.subType !== 1 && <div data-testid="mobile-view-subscription-valid-date-container"> {userDetails?.sub?.subscriptionValidTillDate}</div>}
                          </div>
                          <div data-testid="mobile-view-subscription-name-container">{isTrialUser ? t('TRIAL_PLATINUM') : userDetails?.sub?.subTypeName}</div>
                        </div>
                      ) : (
                        <div className="date-time-wrapper" data-testid="mobile-view-guest-user-date-time-container">
                          <div className="current-date" data-testid="mobile-view-guest-user-date-container">
                            {currentDate}
                          </div>
                          <div className="current-time" data-testid="mobile-view-guest-user-time-container">
                            {currentTime}
                          </div>
                        </div>
                      )}

                      {appSettings?.showrenewal && userDetails?.sub?.renewProcess ? (
                        <div onClick={() => setDrawerState(false)} data-testid="mobile-view-renew-container">
                          {appSettings?.showrenewal && (
                            <button className="upgradeButton renew-button" data-testid="mobile-view-renew-button" onClick={navigateToSubscription} style={borderStyle}>
                              {isTrialUser ? t('BUY_NOW') : userDetails?.sub?.renewProcess}
                            </button>
                          )}
                        </div>
                      ) : (
                        <div>
                          <button className="upgradeButton guest-user-text-border" data-testid="mobile-view-create-account" onClick={(e) => handleShowAppLinks(e)}>
                            <div className="renew-text">{t('CREATE_ACCOUNT_BUTTON_LABEL')}</div>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="sidebar-menus-wrapper" data-testid="sidebar-menus-wrapper-container">
                    <div className={`business-general-container-sidebar ${isLoading ? 'is-loading' : ''}`}>
                      <div
                        className={`business-container ${activeTab === 'business' ? 'active-tab' : ''}`}
                        onClick={() => handleTabSwitch('business')}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault()
                            handleTabSwitch('business')
                          }
                        }}
                      >
                        BUSINESS
                      </div>
                      <div
                        className={`general-container ${activeTab === 'general' ? 'active-tab' : ''}`}
                        onClick={() => handleTabSwitch('general')}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault()
                            handleTabSwitch('general')
                          }
                        }}
                      >
                        GENERAL
                      </div>
                    </div>
                    <div className="sideMenu-container" data-testid="sidebar-menus-container">
                      {filteredMenus &&
                        filteredMenus
                          .filter((ele) => {
                            // Exclude items with submenus (they're handled separately)
                            const hasSubMenus = ele.subMenuModels?.length > 0
                            // Check display flags like Menubar does
                            const isDisplayable = ele.isWebDisplayEnable === true && ele.isLaunch === true && ele.menuUrl !== null && ele.menuUrl !== 'NA'

                            return !hasSubMenus && isDisplayable
                          })
                          .map((ele, index) => (
                            <div key={index} className="menu-icons-container" data-testid="sidebar-menu-icons-container" onClick={() => setDrawerState(false)}>
                              <NavLink
                                exact
                                to={getMenuNavigationUrl(ele?.menuUrl)}
                                className="nav-link-container"
                                isActive={(match, location) => {
                                  // Normalize menuUrl for comparison
                                  const normalizedMenuUrl = ele?.menuUrl?.replace(/^\//, '')?.toLowerCase()

                                  // For coffeeweb view menus, check if we're on coffeeweb route with matching view param
                                  if (coffeewebViewMenus.includes(normalizedMenuUrl)) {
                                    const params = new URLSearchParams(location.search)
                                    const view = params.get('view')

                                    return location.pathname === ROUTE_STRINGS.coffeeweb && view?.toLowerCase() === normalizedMenuUrl
                                  }
                                  // For other menus, use default NavLink active matching

                                  return match !== null
                                }}
                              >
                                <div className="menu-icons" data-testid="sidebar-menu-image-container">
                                  {ele?.menuIcon !== 'NA' && <img alt="" src={ele?.menuIcon} className="menu-image" title="sidebar-menu-image" />}
                                </div>
                                <div className="menu-name" data-testid="sidebar-menu-name-container">
                                  {ele?.menuName}
                                </div>
                              </NavLink>
                            </div>
                          ))}

                      {/* Explore Menu Item */}
                      {/* {exploreMenu && subMenus?.length > 0 && (
                        <div className="sub-menu-dialog-container">
                          <div className="menu-icons-container" onClick={() => setDialogVisible(true)} data-testid="menu-icons-container">
                            <div className="nav-link-container">
                              <div className="explore-menu-container">
                                {subMenus?.slice(0, 2).map((subMenu) => (
                                  <div key={subMenu.id} className="explore-menu-content">
                                    <img alt={subMenu.menuName} src={subMenu?.menuIcon} className="explore-menu-image" />
                                  </div>
                                ))}
                              </div>
                              <div className="menu-name">{exploreMenu.menuName}</div>
                            </div>
                          </div>

                          <Dialog visible={isDialogVisible} dismissableMask={true} header={t('EXPLORE_MENU_HEADING')} onHide={() => setDialogVisible(false)} className="sidebar-menu-dialog" closable={false} maskClassName="explore-menu-mask-style">
                            <div className="submenu-container">
                              {subMenus?.map((subMenu) => (
                                <NavLink
                                  key={subMenu.id}
                                  to={subMenu.menuUrl}
                                  className="submenu-item"
                                  onClick={() => {
                                    setDialogVisible(false)
                                    setDrawerState(false)
                                    handleExploreMenuURL(subMenu)
                                  }}
                                >
                                  <img alt={subMenu.menuName} src={subMenu?.menuIcon} className="menu-image" title="sidebar-menu-image" />
                                  <p className="sub-menu-p">{subMenu.menuName}</p>
                                </NavLink>
                              ))}
                            </div>
                          </Dialog>
                        </div>
                      )} */}

                      {/* Guest User Menus */}
                      {!userLoginStatus && (
                        <>
                          {getFreeMenusToDisplay()
                            ?.slice()
                            ?.sort((a, b) => (a.mobileDisplayOrder ?? 999) - (b.mobileDisplayOrder ?? 999))
                            ?.map((ele, index) => (
                              <React.Fragment key={index}>
                                {ele?.isFreeMenuWebDisplayEnable && ele?.isLaunch && ele?.menuUrl && (
                                  <div key={index} className="menu-icons-container" data-testid="sidebar-guest-user-container">
                                    <NavLink
                                      exact
                                      to={ele.menuUrl === 'CoffeeQuotes' ? ROUTE_STRINGS.guestCoffeeQuotes : ele.menuUrl}
                                      className="nav-link-container"
                                      onClick={(e) => {
                                        if (ele.menuName === 'CoffeeWeb') {
                                          e.preventDefault()
                                          setDialogVisible(true)
                                        }

                                        if (!userDetails) {
                                          handleShowAppLinks(e)

                                          return
                                        }
                                        setDrawerState(false)
                                      }}
                                    >
                                      <div className="menu-icons" data-testid="sidebar-guest-user-menu-image-container">
                                        {ele?.menuIcon !== 'NA' && <img alt="" src={ele?.menuIcon} className="menu-image" title="guest-user-menu-images-tag" />}
                                      </div>
                                      <div className="menu-name" data-testid="sidebar-guest-user-menu-name-container">
                                        {ele?.menuName}
                                      </div>
                                    </NavLink>
                                  </div>
                                )}
                              </React.Fragment>
                            ))}

                          {freeSubMenus && freeSubMenus.subMenuModels?.length > 0 && (
                            <div className="free-sub-menu-dialog-container">
                              {/* Kept it for future reference for explore menu */}
                              {/* <div className="menu-icons-container" onClick={() => setDialogVisible(true)} data-testid="guest-user-menu-icons-container">
                                <div className="nav-link-container">
                                  <div className="explore-menu-container">
                                    {freeSubMenus.subMenuModels.slice(0, 2).map((subMenu) => (
                                      <div key={subMenu.id} className="explore-menu-content">
                                        <img alt="" src={subMenu?.menuIcon} className="explore-menu-image" />
                                      </div>
                                    ))}
                                  </div>
                                  <div className="menu-name">{freeSubMenus.menuName}</div>
                                </div>
                              </div> */}

                              {/* Dialog for Guest User Submenus  */}
                              <div className="free-mobile-menu">
                                <Dialog visible={isDialogVisible} dismissableMask={true} header={t('DEFAULT_COFFEE_WEB_TITLE')} onHide={() => setDialogVisible(false)} className="sidebar-menu-dialog" closable={false} maskClassName="free-explore-menu-mask-style">
                                  <div className="submenu-container">
                                    {freeSubMenus.subMenuModels
                                      ?.slice()
                                      ?.sort((a, b) => (a.mobileDisplayOrder ?? 999) - (b.mobileDisplayOrder ?? 999))
                                      ?.map((subMenu) => (
                                        <NavLink
                                          key={subMenu.id}
                                          to={subMenu.menuUrl}
                                          className="submenu-item"
                                          onClick={(e) => {
                                            if (!userDetails) {
                                              handleShowAppLinks(e)
                                              setDialogVisible(false)

                                              return
                                            }

                                            setDrawerState(false)
                                          }}
                                        >
                                          <img alt={subMenu.menuName} src={subMenu?.menuIcon} className="menu-image" title="sidebar-menu-image" />
                                          <p className="sub-menu-p">{subMenu.menuName}</p>
                                        </NavLink>
                                      ))}
                                  </div>
                                </Dialog>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  {showAppLikns && (
                    <div className={`app-links-in-sidebar ${buzzAnimation ? 'buzz' : ''}`}>
                      <AppLinks />
                    </div>
                  )}

                  <div className="buy-subscription-container"></div>
                </div>

                {/* TODO : FOR THE FUTURE RELEASE */}
                {/* <div className="sidebar-version-number">{Package.version}</div> */}
                {/* --------Footer In Mobile Screen-------- */}

                <div className="sidebar-footer-wrapper">
                  <div className="side-bar-footer-container">
                    {
                      <div className="sidebar-footer-action-wrapper" data-testid="sidebar-logout-wrapper">
                        <div className="toggle-container">
                          <div className={`toggle-switch ${currentTheme === 'dark' ? 'dark' : 'light'}`} onClick={() => handleClickThemeChange()} data-testid="toggle-switch-button">
                            <div className="toggle-text">{currentTheme === 'dark' ? t('LIGHT_MODE') : t('DARK_MODE')}</div>
                            <div className="toggle-circle">{currentTheme === 'dark' ? <i className="pi pi-sun theme-switch-icon"></i> : <i className="pi pi-moon theme-switch-icon"></i>}</div>
                          </div>
                        </div>
                        {!userLoginStatus && (
                          <div className="create-account-text" data-testid="create-account-text-container">
                            To enjoy more features{' '}
                            <span className="create-account-label" onClick={handleShowAppLinks}>
                              {' '}
                              {t('CREATE_ACCOUNT_BUTTON_LABEL')}
                            </span>
                          </div>
                        )}
                        <div className="sidebar-action-logout" data-testid="sidebar-logout-container">
                          {userLoginStatus ? (
                            <div className="logout-button sidebar-logout-button" data-testid="sidebar-logout-logged-user-button" onClick={() => showLogoutConfirmationModal()}>
                              <i className="pi pi-power-off" data-testid="logged-user-power-off-icon"></i>
                              <div className="logout">{t('LOGOUT')}</div>
                            </div>
                          ) : (
                            <>
                              <div className="logout-button guest-user-text-border" data-testid="sidebar-logout-guest-user-button" onClick={(e) => handleShowAppLinks(e)}>
                                <i className="pi pi-sign-in" data-testid="guest-user-sign-in-icon"></i>
                                <div className="logout">{t('LOGIN_BUTTON')}</div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    }
                  </div>
                  <div className="sidebar-footer" data-testid="sidebar-footer-container">
                    <div className="sidebar-footer-copyright" style={{ textAlign: 'center' }}>
                      {t('COPYRIGHT')} <b>{t('COFFEE_WEB')}</b>
                    </div>
                    <div className="sidebar-footer-terms" style={{ display: 'flex', justifyContent: 'center' }}>
                      {t('ALL_RIGHTS_RESERVED')}
                      <a href={STATIC_ROUTE_STRINGS.termsAndCondition} target="_blank" rel="noreferrer">
                        {t('TERMS_CONDITIONS')}
                      </a>
                      <span className="">{t('AND')}</span>
                      <a href={STATIC_ROUTE_STRINGS.privacyPolicy} target="_blank" rel="noreferrer">
                        {t('PRIVACY_POLICY')}
                      </a>
                    </div>
                  </div>
                </div>
              </Sidebar>
            </div>
          )}

          <div className="forMobileScreen mobile-screen-display-page" data-testid="mobile-view-header-container">
            {displayUrl}
          </div>

          <div className="subActionsContainer" data-testid="header-action-container">
            <div className="theme-switch-toogle-button" onClick={() => handleClickThemeChange()} data-testid="theme-switch-toggle-button">
              {currentTheme === 'dark' ? <i className="pi pi-sun theme-switch-icon"></i> : <i className="pi pi-moon theme-switch-icon"></i>}
            </div>
            {userLoginStatus ? (
              <div className="subActionsDiv" data-testid="action-button">
                <div className="forLargeScreen" data-testid="profile-card-container">
                  {userDetails?.userType !== 0 && (
                    <div className="avatarContainer" onMouseEnter={handleProfileMouseEnter} data-testid="avatar-container">
                      <div
                        onClick={() => {
                          setModalShow(true)
                          trackEvent(USER_EVENTS.PROFILE_SCREEN) // user-analytics
                        }}
                        className="avatar-logo"
                        data-testid="avatar-logo"
                      >
                        {userDetails?.firstName?.substr(0, 1).toUpperCase()}
                      </div>
                      <div
                        className="avatarCard"
                        onClick={() => {
                          setModalShow(true)
                          trackEvent(USER_EVENTS.PROFILE_SCREEN) // user-analytics
                        }}
                        style={{
                          '--custom-background': generateLinearGradientColor()
                        }}
                        data-testid="avatar-card"
                      >
                        <div className="avatarDiv" data-testid="avatar-div-container">
                          <div>
                            <img alt="" className="avatarUserCountryImg" src={userDetails?.countryFlag} title="avatar-country-flag" />
                          </div>
                          <div className="avatar-user-personal-details" data-testid="user-personal-details-container">
                            <div className="username-edit-button" data-testid="user-name-container">
                              <div>
                                {userDetails?.firstName} {userDetails?.lastName}
                              </div>
                              <div>
                                <i className="pi pi-pencil" data-testid="pencil-icon-container" />
                              </div>
                            </div>
                            {userDetails?.occupationName !== 'NA' && (
                              <div className="user-occupation" data-testid="user-occupation-container">
                                {userDetails?.occupationName}
                              </div>
                            )}

                            {userDetails?.phone && (
                              <div data-testid="user-phone-container">
                                {t('PHONE')} : + {userDetails?.countryPhoneCode} {userDetails?.phone}
                              </div>
                            )}
                            {userDetails?.email && (
                              <div data-testid="user-email-container">
                                {t('EMAIL')} : {userDetails?.email}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="userSubscriptionDetails" data-testid="user-subscription-details-container">
                          <div className="subscriptionDate" data-testid="subscription-date-and-valid-days-container">
                            {userDetails?.sub?.endDate && userDetails?.sub?.subType !== 1 && <div data-testid="subscription-valid-days-container"> {userDetails?.sub?.subscriptionValidTill}</div>}
                            {userDetails?.sub?.endDate && userDetails?.sub?.subType !== 1 && <div data-testid="subscription-valid-date-container"> {validityFormatter(userDetails?.sub?.subscriptionValidTillDate)}</div>}
                          </div>
                          <div className="subscriptionType" data-testid="user-subscription-name">
                            {isTrialUser ? t('TRIAL_PLATINUM') : userDetails?.sub?.subTypeName}
                          </div>
                        </div>
                        {appSettings?.showrenewal && userDetails?.sub?.renewProcess && (
                          <div className="upgrade-button-large-screen-container" data-testid="upgrade-button-container">
                            {appSettings?.showrenewal && (
                              <button className="upgradeButtonLargeScreen" data-testid="upgrade-action-container" onClick={navigateToSubscription}>
                                {isTrialUser ? t('BUY_NOW') : userDetails?.sub?.renewProcess}
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {userDetails?.userType !== 0 && (
                  <div data-testid="notification-list-in-header">
                    <NotificationListenService overlayPanelRef={overlayPanelRef} />
                  </div>
                )}

                <div className="forLargeScreen hoverOnLogout" data-testid="logout-container">
                  <i className="pi pi-power-off logout-icon" onClick={showLogoutConfirmationModal} data-testid="logout-icon"></i>
                  <div className="tooltipLogout" onClick={showLogoutConfirmationModal} data-testid="logout-tooltip-container">
                    <div>{t('LOGOUT')}</div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {currentUrl !== 'login' && currentUrl !== 'create_account' && (
                  <div>
                    <div className="auth-screen-button forLargeScreen" onClick={handleLogin} data-testid="login-and-create-account-button">
                      {t('LOGIN_AND_CREATE_ACCOUNT')}
                    </div>
                    <div className="forMobileScreen" data-testid="ham-burger-container">
                      <i className="pi pi-bars mobileScreenMenuIcon" onClick={() => setDrawerState(true)} data-testid="ham-burger-icon"></i>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {userLoginStatus && (
        <div>
          <LogoutModal showLogoutPopup={showLogoutPopup} isLogoutModalVisible={isLogoutModalVisible} setIsLogoutModalVisible={setIsLogoutModalVisible} />
          {modalShow && <ProfileModal show={modalShow} setModalShow={setModalShow} onHide={handleClose} />}
        </div>
      )}
    </>
  )
}

export default Header
